import { PropsWithChildren, useCallback } from 'react';
import { VdsButton, VdsIcon } from '@volt/volt-extended-components-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChartCard } from '@customer/components/charts/chart-card/ChartCard';

interface ChartCardProps {
  title: string;
  to: string;
}

const SummaryChartCard = ({ title, to, children }: PropsWithChildren<ChartCardProps>) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClickNavigate = useCallback(() => {
    navigate(to);
  }, [navigate, to]);

  return (
    <ChartCard
      title={title}
      controls={
        <VdsButton variant="secondary" onClick={onClickNavigate}>
          {t('Details')}
          <VdsIcon slot="icon-right" svgIcon="arrow-right" />
        </VdsButton>
      }
      pad={true}
    >
      {children}
    </ChartCard>
  );
};

export default SummaryChartCard;
